import FirstSection from './sections/FirstSection';
import FromIdeaToDeploymentSection from './sections/FromIdeaToDeploymentSection';
import UseCasesSection from './sections/UseCases';
import CreateAvatarSection from './sections/CreateAvatarSection';
import AiModalSection from './sections/AiModalSection';

export default function Agent3DPage() {
  return (
    <div data-cy='agent3d-page'>
      <FirstSection />
      <FromIdeaToDeploymentSection />
      <AiModalSection />
      <UseCasesSection />
      <CreateAvatarSection />
    </div>
  );
}
